import React, { useCallback } from 'react';
import {
  Button, Link, ButtonProps, LinkProps,
} from '@fluentui/react-components';
import { useDataSelection } from '@bingads-webui-react/data-selection';
import { AggregationMode, I18n } from '../types';
import { useAggregatedData } from '../context';

interface InternalSelectAllButton {
  i18n: I18n;
  mode?: AggregationMode;
  as?: 'button' | 'link';
}

type SelectAllButtonProps = InternalSelectAllButton & Omit<ButtonProps | LinkProps, 'onClick' | 'as'>;

export const SelectAllButton: React.FC<SelectAllButtonProps> = ({
  i18n, mode = 'all', as = 'button', ...props
}) => {
  const { getAggregatedData } = useAggregatedData();
  const { setDataSelection } = useDataSelection();

  const onClick = useCallback(() => {
    const items = getAggregatedData(mode);

    const newSelection = items.map(({ value, content, data }) => ({ value, content, data }));

    setDataSelection(newSelection);
  }, [mode, getAggregatedData, setDataSelection]);

  const Component = as === 'button' ? Button : Link;

  return (
    <Component {...props as any} onClick={onClick}>
      {i18n.getString(_TL_('Select all'))}
    </Component>
  );
};
